module.exports = __webpack_public_path__ + "media/images/logos/chrome-store-34236d84f80114b80b3d94d6bf2016be.png";